function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M10 15c-2.54 0-4.69 1.092-6 1.96C5.632 18.232 7.72 19 10 19s4.365-.767 6-2.04c-1.313-.87-3.463-1.96-6-1.96z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.487 10-10c0-5.514-4.486-10-10-10zm5.603 15.7C14.2 14.84 12.257 14 10 14c-2.256 0-4.2.842-5.604 1.7C2.92 14.248 2 12.23 2 10c0-4.41 3.59-8 8-8s8 3.59 8 8c0 2.23-.92 4.248-2.397 5.7zM6.15 17.01C7.217 16.456 8.536 16 10 16s2.782.457 3.85 1.008c-1.143.63-2.455.992-3.85.992s-2.708-.362-3.85-.99zM10 10c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-6C7.794 4 6 5.794 6 8s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/accounts.649a56ae.svg";
export { SvgComponent as ReactComponent };